<template>
  <div>
    <transition name="fullpage-spinner">
      <div v-if="getSpinnerVisibilityStatus" class="full-page-spinner__wrapper">
        <v-progress-circular
          :size="120"
          :width="7"
          color="primary"
          indeterminate
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FullPageSpinner',
  computed: {
    ...mapGetters(['getSpinnerVisibilityStatus'])
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable */
$spinner-background: rgba(#fff, 0.5);

.full-page-spinner {
  &__wrapper {
    z-index: 999999;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: $spinner-background;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/AFullPageSpinner/index.vue